export const PHONE_DISPLAY = "(519) 760-0444";
export const PHONE_TEL = "tel:+15197600444";
export const EMAIL = "info@mtcrenovation.ca";
export const WEBSITE = "mtcrenovation.ca";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const K1 = "https://images.unsplash.com/photo-1682888813913-e13f18692019?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
const K2 = "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
const K3 = "https://images.unsplash.com/photo-1639405069836-f82aa6dcb900?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
const B1 = "https://images.unsplash.com/photo-1638799869566-b17fa794c4de?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
const B2 = "https://images.unsplash.com/photo-1696987007764-7f8b85dd3033?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
const B3 = "https://images.unsplash.com/photo-1631048499052-e6d9f305d2c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
const C2 = "https://images.unsplash.com/photo-1544164560-adac3045edb2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const IMAGES = { K1, K2, K3, B1, B2, B3, C2 };

export const SERVICES = [
  { id: "kitchens", title: "Kitchen Renovations", image: K1,
    desc: "Custom cabinetry, stone counters and precise finish work that make the kitchen the best room in your home." },
  { id: "bathrooms", title: "Bathroom Renovations", image: B1,
    desc: "Clean, modern bathrooms — walk-in showers, floating vanities and tilework done right." },
  { id: "basements", title: "Basement Renovations", image: K2,
    desc: "Turn an unused lower level into warm, finished living space your family actually uses." },
  { id: "flooring", title: "Flooring", image: B2,
    desc: "Hardwood, engineered plank and luxury vinyl installed over level, quiet subfloors." },
  { id: "interiors", title: "Interior Renovations & Painting", image: K3,
    desc: "Drywall, trim, baseboards, doors and professional painting — the details that finish a home." },
  { id: "full-home", title: "Complete Home Renovations", image: C2,
    desc: "Whole-home transformations managed by one crew, one schedule and one accountable team." },
];

export const PROJECTS = [
  { id: 1, title: "Modern Kitchen Renewal", category: "Kitchens", area: "Toronto", image: K1,
    blurb: "Opened-up main floor with a waterfall island and full-height custom cabinetry." },
  { id: 2, title: "Spa Bathroom Retreat", category: "Bathrooms", area: "Mississauga", image: B1,
    blurb: "Freestanding soaker tub, curbless glass shower and a floating double vanity." },
  { id: 3, title: "Warm Family Basement", category: "Basements", area: "Brampton", image: K2,
    blurb: "A dark lower level transformed into a bright, comfortable family space." },
  { id: 4, title: "Main Floor Transformation", category: "Full Home", area: "Vaughan", image: K3,
    blurb: "Kitchen, flooring, trim and paint — a complete main-floor refresh." },
  { id: 5, title: "Ensuite Refresh", category: "Bathrooms", area: "Oakville", image: B2,
    blurb: "Large-format tile, backlit mirrors and modern matte black fixtures." },
  { id: 6, title: "Custom Vanity & Millwork", category: "Interiors", area: "Markham", image: B3,
    blurb: "Hand-fitted walnut vanity with a stone top and concealed storage." },
];

export const PROJECT_FILTERS = ["All", "Kitchens", "Bathrooms", "Basements", "Interiors", "Full Home"];

export const AREAS = ["Toronto", "Mississauga", "Brampton", "Vaughan", "Markham", "Richmond Hill", "Oakville", "Burlington", "Kitchener", "Waterloo", "Cambridge", "Guelph"];

export const FAQS = [
  { q: "What renovation services do you provide?", a: "Kitchen, bathroom and basement renovations, flooring, interior renovations and painting, and complete home renovations — all handled by our own crew across the GTA." },
  { q: "How much does a home renovation cost in the GTA?", a: "It depends on size, materials and condition. Bathrooms typically start around $15,000 and kitchens around $25,000. Request a free estimate for an exact fixed-price quote." },
  { q: "Do you provide free estimates?", a: "Yes. Every project starts with a free consultation and ends with a written, fixed-price quote. No obligation." },
  { q: "How long does a renovation take?", a: "Bathrooms typically run 2–4 weeks and kitchens 3–6 weeks; urgent work can be prioritized. You receive a written schedule before work begins." },
  { q: "Do you work throughout the GTA?", a: "Yes — Toronto, Mississauga, Brampton, Vaughan, Markham, Richmond Hill, Oakville, Burlington and everywhere in between." },
  { q: "Are you licensed and insured?", a: "Yes, fully licensed and insured, and every project includes a 2-year workmanship warranty." },
  { q: "How do I start a project?", a: "Request a free estimate online or call (519) 760-0444. We'll discuss your goals, visit your home, and provide a written quote." },
];
